import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css"; 

import img111 from '../assets/111.webp';
import img222 from '../assets/222.webp';
import img333 from '../assets/333.webp';
import img444 from '../assets/444.webp';
import img555 from '../assets/555.webp';
import img666 from '../assets/666.webp';
import img777 from '../assets/777.webp';
import img888 from '../assets/888.webp';
import img999 from '../assets/999.webp';

const ServingPanIndia = () => {
  const stats = [
    { label: "Installations", value: 1000, suffix: "+" },
    { label: "Clients", value: 500, suffix: "+" },
    { label: "Years of Experience", value: 25, suffix: "+" },
  ];

  const clientLogos = [img111, img222, img333, img444, img555, img666, img777, img888, img999];

  // State to trigger CountUp
  const [startCount, setStartCount] = useState(false);

  useEffect(() => {
    // Start counting after component mounts
    setStartCount(true);
  }, []);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    cssEase: "linear",
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 5 } },
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div>
      {/* Stats Section */}
      <section
        className="relative py-16 hero-bg-color"
      >
        <div className="relative max-w-7xl mx-auto px-6 text-center text-white">
          <h2 className="text-3xl md:text-4xl font-bold mb-12">
            Serving Over Pan India
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="bg-white bg-opacity-20 backdrop-blur-md rounded-xl shadow-lg p-6 md:p-8 transition transform hover:scale-105"
              >
                <h3 className="text-3xl sm:text-4xl font-extrabold text-yellow-300">
                  {startCount ? (
                    <CountUp
                      start={0}
                      end={stat.value}
                      duration={5}   // Slow, smooth animation
                      separator=","
                      suffix={stat.suffix}
                    />
                  ) : (
                    0
                  )}
                </h3>
                <p className="mt-2 text-lg sm:text-lg font-semibold text-white">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Clients Slider */}
      <section className="py-16 bg-gray-100">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 px-4 sm:px-6">
          Our Valuable Clients in India
        </h2>
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <Slider {...sliderSettings}>
            {clientLogos.map((logo, index) => (
              <div key={index} className="flex justify-center items-center p-2 sm:p-4">
                <img
                  src={logo}
                  alt={`Client ${index + 1}`}
                  className="h-32 sm:h-40 md:h-44 object-contain"
                />
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </div>
  );
};

// Custom Arrows
function SampleNextArrow(props) {
  const { className, onClick } = props;
  return <div className={`${className} text-blue-500 cursor-pointer`} onClick={onClick} />;
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return <div className={`${className} text-blue-500 cursor-pointer`} onClick={onClick} />;
}

export default ServingPanIndia;
